import React, {Component} from 'react'
import {style, media, merge} from 'glamor'
import * as colors from '../colors'
import Menu from './Menu'
import TweenMax from 'gsap'
import {Burger, X} from 'reline'
import {ButtonCircle} from 'rebass'

export default class HomeMobile extends Component {

  constructor(props){
    super(props)
    this.isMenuOpen = false
    this.toggleMenu = this.toggleMenu.bind(this)
    this.resize = this.resize.bind(this)
    this.pageRefs = {}
    this.handlePage = this.handlePage.bind(this)
  }

  shouldComponentUpdate(){
    return false
  }

  handlePage(url, node){
    this.pageRefs[url] = node
  }

  componentDidMount(){
    window.addEventListener('resize', this.resize, false)
    this.resize()
    if(window.__SCROLL_HOME__){
      window.scrollTo(0, window.__SCROLL_HOME__)
    }
  }

  componentWillUnmount(){
    window.__SCROLL_HOME__ = window.pageYOffset
    window.removeEventListener('resize', this.resize, false)
  }

  componentWillReceiveProps(newProps){
    if(newProps.location.pathname !== this.props.location.pathname){
      this.slideTo(this.pageRefs[newProps.location.pathname])
    }
  }

  toggleMenu(){
    this.isMenuOpen = !this.isMenuOpen
    TweenMax.to(this.refs.menu, 0.7, {
      x: this.isMenuOpen ? '0%' : '100%',
      ease: TweenMax.Expo.easeInOut
    })

    TweenMax.to(this.refs.btnMenuBurger, 0.4, {
      opacity: this.isMenuOpen ? 0 : 1,
      ease: TweenMax.Expo.easeOut
    })

    TweenMax.to(this.refs.btnMenuClose, 0.4, {
      opacity: this.isMenuOpen ? 1 : 0,
      ease: TweenMax.Expo.easeOut
    })
  }

  slideTo(node){
    if(!node) return
    const nodeY = node.offsetTop
    window.scrollTo(0, nodeY)
  }

  resize(){
  }

  render(){
    return (
      <div
        ref='container'
        {...style({
          width: '100%',
          background: colors.almostWhite,
          color: colors.darkGray,
          overflow: 'hidden'
        })}
      >
        <div>
          { this.props.pages.map((page, i)=>{
            const Comp = page.component
            // console.log(page)
            return (
              <div
                key={page.url}
                ref={node => this.handlePage(page.url, node)}
                {...style({
                  marginBottom: '2rem',
                  padding: '1.5rem'
                })}
              >
                {<Comp {...page}/>}
              </div>
            )
          })}
        </div>

        <div
          onClick={this.toggleMenu}
          {...merge(
            style({
              cursor: 'pointer',
              position: 'fixed',
              top:0,
              right: 0,
              zIndex: 9,
              padding: '1rem',
            }),
            media('(min-width: 800px)', {
              display: 'none',
            })
          )}
        >
        <ButtonCircle
          size={40}
          backgroundColor={colors.yellow}
        >
          <div
            style={{
              position: 'relative'
            }}
          >
            <div
              ref='btnMenuBurger'
              {...style({
                color: colors.white,
              })}
            >
              <Burger style={{display: 'block'}}strokeWidth={2}/>
            </div>
            <div
              ref='btnMenuClose'
              {...style({
                position: 'absolute',
                top: 0,
                left: 0,
                opacity: 0,
                color: colors.white
              })}
            >
              <X style={{display: 'block'}}strokeWidth={2}/>
            </div>
            </div>
          </ButtonCircle>
        </div>

        <div
          ref='menu'
          {...merge(
            style({
              background: colors.yellow,
              color: colors.darkGray,
              position: 'fixed',
              top:0,
              left: 0,
              width: '100%',
              height: '100%',
              padding: '3rem',
              transform: 'translate3d(100%, 0, 0)',
              willChange: 'transform',
              display: 'flex',
              zIndex: 6,
              alignItems: 'center'
            })
          )}
        >
          <Menu
            borderColor={colors.white}
            activeColor={colors.white}
            normalColor={colors.darkGray}
            underlineColor={colors.darkGray}
            onItemClick={()=> this.isMenuOpen && this.toggleMenu() }
            pages={this.props.pages}
          />
        </div>
      </div>
    )
  }
}



/** WEBPACK FOOTER **
 ** ./src/components/HomeMobile.js
 **/